export const useLoading = () => {
  const loading = ref(false)
  const loadedOnce = ref(false)

  watch(loading, (val, oldVal) => {
    if (val === false && oldVal === true) {
      loadedOnce.value = true
    }
  })

  return { loading, loadedOnce }
}
